import { atomWithReset } from 'jotai/utils';
import { atom } from 'jotai/index';
import {
  IeltsListeningCheckPoint,
  IeltsReadingCheckPoint,
  StepInstructionListeningReading,
} from '@/types';

export const ieltsListeningCheckPointAtom = atomWithReset<IeltsListeningCheckPoint | undefined>(
  undefined,
);

export const ieltsReadingCheckPointAtom = atomWithReset<IeltsReadingCheckPoint | undefined>(
  undefined,
);

export const listeningReadingStepInstructionAtom = atom<StepInstructionListeningReading>(
  StepInstructionListeningReading.PreviewCheckPoint,
);

export const activeQuestionIdAtom = atomWithReset<string | undefined>(undefined);

export const listeningListPartAtom = atom((get) => {
  const checkpoint = get(ieltsListeningCheckPointAtom);

  return checkpoint?.checkPointIeltsListeningParts || [];
});

export const selectedListeningPartsAtom = atomWithReset<
  IeltsListeningCheckPoint['checkPointIeltsListeningParts']
>([]);

export const selectedReadingPartsAtom = atomWithReset<
  IeltsReadingCheckPoint['checkPointIeltsReadingParts']
>([]);

export const activeListeningPartAtom = atomWithReset<
  IeltsListeningCheckPoint['checkPointIeltsListeningParts'][number] | undefined
>(undefined);

export const activeReadingPartAtom = atomWithReset<
  IeltsReadingCheckPoint['checkPointIeltsReadingParts'][number] | undefined
>(undefined);

export const attemptIdAtom = atomWithReset<string | undefined>(undefined);

export const openIeltsInfoDrawerAtom = atomWithReset(false);

export const openModalLeaveExamAtom = atomWithReset(false);

export const loadingSubmitIeltsAtom = atomWithReset(false);
export const isHideSideBarAtom = atomWithReset(false);

export const practiceModeDataAtom = atomWithReset<
  | {
      timeLimit: number;
    }
  | undefined
>(undefined);

export const doExamTimeAtom = atomWithReset<number>(0);


export const doExamTimeCountDownAtom = atomWithReset<number>(0);

export const viewReportUserAttemptAtom = atomWithReset<any | undefined>(undefined);

export const submitAttemptCallbackAtom = atomWithReset<(() => Promise<void>) | undefined>(
  undefined,
);
